import NewsItemContent from './NewsItemContent'
import NewsItemContentLoading from './NewsItemContentLoading'

export { NewsItemContentLoading }
export default NewsItemContent
